import React from 'react';
import VideoCard from '../../components/VideoCard';
import Navbar from "../../components/NavBar";

const VideoCardList = ({ cards }) => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <div className="container mx-auto p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ">
          {cards.map((card, index) => (
            <React.Fragment key={index}>
              <VideoCard
                imageSrc={card.imageSrc}
                title={card.title}
                duration={card.duration}
                videoUrl={card.videoUrl}
              />
              {/* Add a separator only for single-column layouts */}
              {index < cards.length - 1 && (
                <div className="block md:hidden h-px bg-white my-0"></div>
              )}
            </React.Fragment>
          ))}
        </div>
        <div className="flex justify-center p-10">MORE COMING SOON...</div>
      </div>
    </div>
  );
};

export default VideoCardList;
